import React from 'react';
import classNames from 'classnames';
import styles from './Table.module.scss';
import { isFunction } from 'lodash';
import { Text, fontWeightEnum, textVariantsEnum } from '../Text';
import { SvgIcon } from '../SvgIcon';
import { SvgIconSrc } from '../SvgIcon/SvgIcon.constants';
export const TableHeader = ({
  column,
  sortedBy,
  reverseSort,
  handleSortClick,
  children,
}) => {
  return (
    <th
      key={column.id}
      id={column.id}
      className={classNames({
        [styles.sortedColumn]: sortedBy === column.id,
        [column.thClassName]: column.thClassName,
      })}
      style={column.style}
    >
      <div className={styles.th_content}>
        {isFunction(column.customHeader) ? (
          column.customHeader(column)
        ) : (
          <Text
            variant={textVariantsEnum.Text_13}
            fontWeight={fontWeightEnum.Medium}
          >
            {column.name}
          </Text>
        )}
        {column.sortable && (
          <SvgIcon
            className={styles.arrowIcon}
            src={SvgIconSrc.arrow}
            rotate={sortedBy === column.sortKey && reverseSort ? '180' : null}
            size={16}
            onClick={() => handleSortClick(column?.sortKey)}
          />
        )}
      </div>
      {children}
    </th>
  );
};
